module.exports = __webpack_public_path__ + "static/media/project-3.1b5bb79c.jpg";